module.exports = [{
      plugin: require('D:/Projekty/wdb-front/work/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-NKPVQX7","includeInDevelopment":true},
    },{
      plugin: require('D:/Projekty/wdb-front/work/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".md",".mdx"],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"maxWidth":1500,"srcSetBreakpoints":[750,1500],"showCaptions":false,"quality":90}}]},
    },{
      plugin: require('D:/Projekty/wdb-front/work/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('D:/Projekty/wdb-front/work/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
